import { find, propEq, when } from 'ramda'
import { isNotNil } from 'ramda-adjunct'
import { redirectToLoginURL } from '../utils/auth'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const isXhrError = (error) => isNotNil(error.response)

const ACTIONS = [
  {
    predicate: (request, response) => propEq(401, `status`, response),
    redirectToLoginURL,
  },
  {
    predicate: (request, response) => propEq(403, `status`, response),
    redirectToLoginURL,
  },
]

const getAction = (request, response) =>
  find((action) => action.predicate(request, response), ACTIONS)

const handleXhrError = (error) => {
  const { request, response } = error

  const action = getAction(request, response)

  if (action && action.redirectTo) {
    action.redirectTo(request, response)
  }
}

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const getErrorService = () => {
  const handleError = (error) => {
    when(isXhrError, handleXhrError)(error)
  }

  return {
    handleError,
  }
}

export default getErrorService
